import { Injectable } from '@angular/core';
import { MadCloudCommit } from '@common/git/models/mad-cloud-commit.model';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: CommitsState
})
@State<CommitsState>({
  name: CommitsState.source
})
@Injectable()
export class CommitsState extends CollectionStateBase {
  static source = 'Commits';
  getSource(): string {
    return CommitsState.source;
  }

}

@Injectable({
  providedIn: 'root'
})
export class CommitsDataService extends CollectionDataServiceBase<MadCloudCommit> {
  constructor(protected store: Store) {
    super(store, CommitsState);
  }
}
